//****************************************
// Light Plot Legend Prototype
// DOM Registration: No
// National Instruments Copyright 2015
//****************************************

/**
## ni-light-plot-legend

> A custom element that provides a light legend for showing plot icons and names.

Use it to visualize the plots of a graph or chart element.

It provides an svg image with all the plots of the graphs.

By changing position attribute you can place the legend over graph("nw", "ne", "sw", "se"), or
inside a container("container"). Default is "container".

Example:
```html
<ni-cartesian-graph graph-ref="g1" value="[[2, 3, 5, 7, 11, 13, 17, 19],
                          [0, 1, 1, 2, 3, 5, 8, 13]]">
    <ni-cartesian-axis show label="Index" axis-position="bottom"></ni-cartesian-axis>
    <ni-cartesian-axis show label="Value" axis-position="left"></ni-cartesian-axis>
    <ni-cartesian-plot show label="Prime Numbers">
        <ni-cartesian-plot-renderer line-width="2" line-stroke="red">
        </ni-cartesian-plot-renderer>
    </ni-cartesian-plot>
    <ni-cartesian-plot show label="Fibonacci Numbers">
        <ni-cartesian-plot-renderer line-width="2" line-stroke="blue">
        </ni-cartesian-plot-renderer>
    </ni-cartesian-plot>
</ni-cartesian-graph>

<ni-light-plot-legend show graph-ref="g1" position="ne"></ni-light-plot-legend>
```
*/

(function() {
    'use strict';

    class LightPlotLegend extends window.JQX.BaseElement {
        /**### ni-light-plot-legend properties*/

        static get properties() {
            const props = Object.assign({}, super.properties, {
                /** **show** (boolean) - the visibility of the plot legend. Default: false.
                 Accepted values: true, false*/
                'show': {
                    value: false,
                    type: 'boolean'
                },
                /** **graph-ref** (string) - the graph id to connect to. Default: ''.*/
                'graphRef': {
                    value: '',
                    type: 'string'
                },
                /** **position** (string) - the position where the legend will be placed. Default: 'container'.
                 Accepted values: 'nw', 'ne', 'sw', 'se', 'container'*/
                'position': {
                    value: 'container',
                    type: 'string'
                }
            });

            return props;
        }

        findGraph() {
            return document.querySelector('ni-cartesian-graph[graph-ref=\'' + this.graphRef + '\']') ||
                document.querySelector('ni-chart[graph-ref=\'' + this.graphRef + '\']');
        }

        propertyChangedHandler(propertyName, oldValue, newValue) {
            super.propertyChangedHandler(propertyName, oldValue, newValue);
            var graphElement = this.findGraph();
            switch (propertyName) {
                case 'position':
                    while (this.hasChildNodes()) {
                        this.removeChild(this.firstChild);
                    }
                    break;
                case 'show':
                    while (this.hasChildNodes()) {
                        this.removeChild(this.firstChild);
                    }
                    break;
            }
            if (graphElement) {
                graphElement.updateGraphConfig();
            }
        };

        addDefaultClass() {
        }
    };

    JQX('ni-light-plot-legend', LightPlotLegend);
}());

class NILightLegendModule {
    static get moduleName() {
        return 'NILightLegendModule';
    }

    getSettings() {
        var settings = this.ownerElement.getSettingsWorkaround();
        var legend = this.findLegend(this.ownerElement.graphRef);

        if (!legend) {
            return settings;
        }

        function getLegendContainer(legend) {
            var container = null;
            if (legend.position !== "nw" &&
                legend.position !== "ne" &&
                legend.position !== "sw" &&
                legend.position !== "se") {
                if (legend.hasChildNodes()) {
                    container = legend.lastChild;
                } else {
                    container = document.createElement('div');
                    legend.appendChild(container);
                }
            }

            return container;
        }

        var legendSettings = {
            show: legend.show,
            container: getLegendContainer(legend), // container (as jQuery object) to put legend in, null means default on top of graph
            position: legend.position,
            margin: 5 // distance from grid edge to default legend container within plot
        };

        settings.legend = legendSettings;
        return settings;
    }

    findLegend(graphRef) {
        return document.querySelector('ni-light-plot-legend[graph-ref=\'' + graphRef + '\']');
    }
}

JQX.Elements.whenRegistered('ni-cartesian-graph', function(proto) {
    proto.addModule(NILightLegendModule);
});

JQX.Elements.whenRegistered('ni-chart', function(proto) {
    proto.addModule(NILightLegendModule);
});
